import React, { useEffect, useState, } from 'react';
import { Modal } from 'react-bootstrap';
import HtmlParser from 'react-html-parser';

import {
    buttonProcessGet, responseGet, globalSettings, styles, sendMessageCloseCurrentWindowAsync, languageObjGet, isUndNullEmp, awaitDelay,
    dateTimeFormatGlobalSet,
} from '../../helpers/settings';
import axios from 'axios';
import { condominiumBoardRoleModelGet } from '../../models/condominiumBoard/role';
import { GlobalFormats } from '../../classes/main/globalFormats';

const currentMethod = 'RoleAddEditDetails';

const { app, icons, images, labels, messages, react: reactSett, } = globalSettings;
const { backend, } = app;

export default function RoleAddEditDetails({
    $ = {},
    auth = {},
    userRole = '',
    condominiumBoardRole = condominiumBoardRoleModelGet({}),
    setCondominiumBoardRole = () => { },
    dtId = '',
    dtRowIndex = 0,
    showModal = false,
    setShowModal = () => { },
    processType = 0,
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const [descriptionError, setDescriptionError] = useState('');
    const [remarkError, setRemarkError] = useState('');
    const [hierarchyError, setHierarchyError] = useState('');
    const controls = {
        buttons: {
            save: {
                className: 'btn btn-outline-warning',
                id: 'btnModalCBRoleSave',
            },
            back: {
                className: 'btn btn-outline-success mx-1',
                id: 'btnModalCBRoleBack',
            },
            close: {
                className: 'close btn-danger fas fa-window-close',
                id: 'btnModalCBRoleClose',
            },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            // buildings: {
            //     inputs: {
            //         search: {
            //             id: `${dtFilesId}_filter input`,
            //             className: '',
            //         },
            //     },
            //     selects: {
            //         entries: {
            //             id: `${dtFilesId}_length select`,
            //             className: '',
            //         },
            //     },
            // },
        },
        icons: {
            save: {
                className: icons?.save,
                id: 'icoModalCBRoleSave',
            },
            back: {
                className: icons?.arrowCircleLeft,
                id: 'icoModalCBRoleBack',
            },
        },
        inputs: {
            title: {
                id: 'inputModalCBRoleName',
                className: 'form-control',
            },
            description: {
                id: 'inputModalCBRoleDescription',
                className: 'form-control',
            },
            hierarchy: {
                id: 'inputModalCBRoleHierarchy',
                className: 'form-control',
            },
        },
        spinners: {
            save: {
                className: '',
                id: 'spModalCBRoleSave',
            },
            back: {
                className: '',
                id: 'spModalCBRoleBack',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion variables

    //#region methods
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const errorDefaultSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'errorDefaultSetAsync';
        let response = responseGet();
        try {
            setRemarkError('');
            setHierarchyError('');
            setDescriptionError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const defaultValueSetAsync = async ({ isModalClose = false, subMethod = '', }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            await errorDefaultSetAsync({ subMethod: currentMethod, });

            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }

            setShowModal(!isModalClose);
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const formDataValidateAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            if (isUndNullEmp({ data: condominiumBoardRole?.description, subMethod: currentMethod, })?.result) {
                setDescriptionError(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: condominiumBoardRole?.remark, subMethod: currentMethod, })?.result) {
                setRemarkError(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: condominiumBoardRole?.hierarchy, subMethod: currentMethod, })?.result ||
                condominiumBoardRole?.hierarchy <= 0) {
                setHierarchyError(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
                response.isWarning = true;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const condominiumBoardRoleAddPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'condominiumBoardRoleAddPostAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            //#region initialize
            await errorDefaultSetAsync({ subMethod: currentMethod, });
            //#endregion initialize

            //#region formDataValidateAsync
            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion formDataValidateAsync

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region create consominiumBoardRole
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                condominiumBoardRole: condominiumBoardRole,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCondominiumBoardRoles}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            const condominiumBoardRoleLocal = response?.result;
            setCondominiumBoardRole(condominiumBoardRoleLocal);
            //#endregion create consominiumBoardRole

            //#region add record dtCondominiumBoardRole
            const dtRows = [
                condominiumBoardRoleLocal?.description,
                condominiumBoardRoleLocal?.hierarchy,
                buttonProcessGet({
                    id: condominiumBoardRoleLocal?.id,
                    description: condominiumBoardRoleLocal?.description,
                    showDetails: true,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: true,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: true,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            ];

            $(`#${dtId}`)?.DataTable()?.row?.add(dtRows)?.draw(true);
            //#endregion add record dtCondominiumBoardRole

            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const condominiumBoardRoleEditPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'condominiumBoardRoleEditPostAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            //#region initialize
            await errorDefaultSetAsync({ subMethod: currentMethod, });
            //#endregion initialize

            //#region formDataValidateAsync
            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion formDataValidateAsync

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region update consominiumBoardRole
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                condominiumBoardRole: condominiumBoardRole,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCondominiumBoardRoles}/${condominiumBoardRole?.id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            const condominiumBoardRoleLocal = response?.result;
            setCondominiumBoardRole(condominiumBoardRoleLocal);
            //#endregion update consominiumBoardRole

            //#region add record dtCondominiumBoardRole
            const dtRows = [
                condominiumBoardRoleLocal?.description,
                condominiumBoardRoleLocal?.hierarchy,
                buttonProcessGet({
                    id: condominiumBoardRoleLocal?.id,
                    description: condominiumBoardRoleLocal?.description,
                    showDetails: true,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: true,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: true,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            ];

            $(`#${dtId}`)?.DataTable()?.row(dtRowIndex).data(dtRows)?.draw(true);

            //defaultValueSetAsync(processType === 0);
            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });
            //#endregion add record dtCondominiumBoardRole

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${reactSett?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${reactSett?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${reactSett?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region inputs
            $(`#${controls?.inputs?.title?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.description?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.hierarchy?.id}`).attr('readOnly', (processType !== 0));
            //#endregion inpust

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : reactSett?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region old code
            // $(`#${controls?.dataTables?.buildings?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.dataTables?.buildings?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion old code

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(`${reactSett?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(reactSett?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(reactSett?.html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'from - onLoad', });
    }, [auth]) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal backdrop='static' show={showModal} onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, })}>
            <Modal.Header>
                <Modal.Title>
                    <img alt={labels?.role?.[languageObj?.id]}
                        style={styles?.cardHeaderLogo}
                        src={images?.condominiumBoardRoles}></img> - {labels?.role?.[languageObj?.id]} ({processType === 0 ?
                            labels?.add?.[languageObj?.id]?.toLowerCase() :
                            processType === 1 ?
                                labels?.edit?.[languageObj?.id]?.toLowerCase() :
                                labels?.detail?.[languageObj?.id]?.toLowerCase()})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, })}
                ></button>
            </Modal.Header>
            <form onSubmit={(e) => processType === 0 ? condominiumBoardRoleAddPostAsync({ e: e, subMethod: 'btn - add', }) : (processType === 1 ? condominiumBoardRoleEditPostAsync({ e: e, subMethod: 'modal - onSubmit', }) : e?.preventDefault())}>
                <Modal.Body>
                    {/* <form onSubmit={(e) => processType === 0 ? condominiumBoardRoleAddPostAsync(e) : (processType === 1 ? condominiumBoardRoleEditPostAsync(e) : e?.preventDefault())}>
                    <div className='card card-primary card-outline shadow-lg'> */}

                    {/*card header*/}
                    {/* <div className='card-header'>
                            <h6 className='card-title'>
                                <img alt={labels?.role?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={images?.condominiumBoardRoles}></img> - {labels?.role?.[languageObj?.id]}
                            </h6>

                        </div> */}

                    {/*card body*/}
                    {/* <div className='card-body '> */}
                    {processType !== 2 ?
                        <div>
                            <div className='row '>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.title?.id}
                                                className={controls?.inputs?.title?.className}
                                                //autoFocus
                                                onChange={(e) => setCondominiumBoardRole({ ...condominiumBoardRole, 'description': e.target.value, })}
                                                onFocus={() => setDescriptionError('')}
                                                placeholder={labels?.name?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.name?.[languageObj?.id]}
                                                value={condominiumBoardRole?.description || ''} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.userTag} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(descriptionError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row '>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <textarea id={controls?.inputs?.description?.id}
                                                className={controls?.inputs?.description?.className}
                                                onChange={(e) => setCondominiumBoardRole({ ...condominiumBoardRole, 'remark': e.target.value, })}
                                                onFocus={() => setRemarkError('')}
                                                placeholder={labels?.description?.[languageObj?.id]}
                                                rows={3}
                                                tooltip='tooltip'
                                                title={labels?.description?.[languageObj?.id]}
                                                value={condominiumBoardRole?.remark || ''}>
                                            </textarea>
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.spellCheck} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(remarkError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row '>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.hierarchy?.id}
                                                className={controls?.inputs?.hierarchy?.className}
                                                max={100}
                                                min={0}
                                                onChange={(e) => setCondominiumBoardRole({ ...condominiumBoardRole, 'hierarchy': parseInt(e.target.value), })}
                                                onFocus={() => setHierarchyError('')}
                                                placeholder={labels?.hierarchy?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.hierarchy?.[languageObj?.id]}
                                                type='number'
                                                value={condominiumBoardRole?.hierarchy || 0}>
                                            </input>
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.sortNumericUpAlt} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(hierarchyError)}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div>
                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.name?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <div className='icheck-primary d-inline'>
                                        <b>{condominiumBoardRole?.description || ''} </b>
                                    </div>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.description?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    {!isUndNullEmp({ data: condominiumBoardRole?.remark, subMethod: currentMethod, })?.result ?
                                        HtmlParser(condominiumBoardRole?.remark?.replaceAll('\n', '<br/>')) : ''}
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.hierarchy?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    {condominiumBoardRole?.hierarchy || 0}
                                </div>
                            </div>

                            {userRole === globalSettings?.roles?.master || userRole === globalSettings?.roles?.admin ?
                                <div>
                                    <hr />
                                    <div className='row text-muted'>
                                        <div className='col-md-4'>
                                            {labels?.created?.[languageObj?.id]}:
                                        </div>
                                        <div className='col-md-8'>
                                            {dateTimeFormatGlobalSet({
                                                date: condominiumBoardRole?.created || new Date(),
                                                type: languageObj?.format?.date?.f1,
                                                format: languageObj?.format?.time?.type,
                                                addTime: false,
                                                languageId: languageObj?.id,
                                                subMethod: currentMethod,
                                            })?.result}
                                        </div>
                                    </div>
                                </div> :
                                <></>
                            }
                        </div>
                    }
                    {/* </div> */}

                    {/*card footer*/}
                    {/* <div className='card-footer'>
                            <div className='form-group text-right'>
                                <button className='btn btn-outline-warning'
                                    hidden={processType === 2}
                                    tooltip='tooltip'
                                    title={labels?.save?.[languageObj?.id]}
                                    type='submit'><i className={icons?.save}></i>
                                </button>
                                <button className='btn btn-outline-success mx-1'
                                    tooltip='tooltip'
                                    title={labels?.close?.[languageObj?.id]}
                                    type='reset'
                                    onClick={() => defaultValueSetAsync(true)}><i className={icons?.arrowCircleLeft}></i>
                                </button>
                            </div>
                        </div> */}
                    {/* </div>
                </form> */}
                </Modal.Body>
                <Modal.Footer>
                    <div className='form-group text-right'>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.className}
                            hidden={processType === 2}
                            tooltip='tooltip'
                            title={labels?.save?.[languageObj?.id]}
                            type='submit'>
                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}
                            type='reset'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}